<template>
  <nav class="navbar">
    <PreLoadSpinner v-if="preLoadSpinner" />
    <v-navigation-drawer
      app
      v-model="drawer"
      :mini-variant="mini"
      permanent
      expand-on-hover
      class="drawer-class"
      v-if="!preLoadSpinner"
    >
      <div
        style="padding: 18px !important; margin: 8px 0"
        class="d-flex stickyHeader"
      >
        <!-- <img
          src="https://i.ibb.co/LxWWBGc/cv-logo-white.png"
          alt="ngp-logo"
          width="45"
          class="clearVueLogo"
        /> -->
        <img
          src="../../src/assets/eye.png"
          alt="ngp-logo"
          width="45"
          class="clearVueLogo"
        />
        <!-- <span
          class="font-weight-bold white-text"
          style="
            position: absolute;
            left: 80px;
            top: 16px;
            font-size: 22px;
            color: #1e1e1e;
          "
          >ClearVUE</span
        > -->
      </div>
      <div class="sidebarList">
        <v-list>
          <v-list-item
            v-for="(item, i) in items"
            :key="i"
            class="text-center mb-4"
          >
            <router-link
              active-class="active"
              :to="item.routeName"
              exact
              class="mx-auto my-0"
            >
              <v-tooltip right color="greyDarken">
                <template v-slot:activator="{ on, attrs }">
                  <v-list-item-icon
                    class="mx-auto"
                    style="margin: 10px 0"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon v-text="item.icon"></v-icon>
                  </v-list-item-icon>
                </template>
                <span>
                  <span class="d-block">{{ item.text }}</span>
                </span>
              </v-tooltip>
              <!-- <v-list-item-content>
                    <v-list-item-title v-text="item.text"></v-list-item-title>
                  </v-list-item-content> -->
            </router-link>
          </v-list-item>
        </v-list>
      </div>

      <v-list-item class="menu-items cursor-pointer" v-on="on">
        <div class="text-left profile-menu">
          <v-menu
            transition="slide-x-transition"
            offset-x
            v-model="menu"
            :close-on-content-click="false"
            :nudge-width="200"
          >
            <template v-slot:activator="{ on }">
              <v-list-item-content class="pa-4">
                <v-list-item-title>
                  <div v-on="on">
                    <!-- <i class="la la-user white--text itemIcon fs-25px"></i> -->
                    <!-- <img src="https://assets.webiconspng.com/uploads/2016/11/avatar_business_costume_male_man_office_user_icon_403022.png" width="50px"> -->
                    <div class="user-avatar">
                      <span>{{ avatarName }}</span>
                    </div>
                    <!-- <span class="user-name-avatar">{{ userName }}</span>
                    <span class="user-position-avatar">{{ userRole }}</span>
                    <span class="status-indicator"></span> -->
                    <v-tooltip right color="greyDarken">
                      <template v-slot:activator="{ on, attrs }">
                        <div
                          class="logout-avatar tooltipBtn"
                          @click="logout"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <i class="las la-sign-out-alt"></i>
                        </div>
                      </template>
                      <span>
                        <span class="d-block">Logout</span>
                      </span>
                    </v-tooltip>
                  </div>
                </v-list-item-title>
              </v-list-item-content>
            </template>
          </v-menu>
        </div>
      </v-list-item>
    </v-navigation-drawer>
    <router-view />
    <div></div>
  </nav>
</template>

<script>
export default {
  data() {
    return {
      on: "",
      menu: null,
      drawer: true,
      mini: true,
      userName: null,
      userRole: null,
      avatarName: null,
      custType: 1,
      userType: 0,
      showSettingsActive: false,
      items: [
        // {
        //   text: "Pre Estimate",
        //   icon: "las la-calculator",
        //   routeName: "preEstimate",
        // },
        {
          text: "Proposal",
          icon: "lar la-handshake",
          routeName: "clearvueProposal",
        },
        // {
        //   text: "Dashboard",
        //   icon: "las la-chalkboard",
        //   routeName: "dashBoard",
        // },
        // {
        //   text: "Order Form",
        //   icon: "las la-file-invoice",
        //   routeName: "orderForm",
        // },
        // {
        //   text: "Pdf Template",
        //   icon: "las la-file-pdf",
        //   routeName: "pdfTemplate",
        // },
      ],
      preLoadSpinner: false,
      roleMenusListFromApi: [],
    };
  },

  methods: {
    logout() {
      localStorage.clear();
      this.$router.push({ path: "/" }).catch(() => {});
    },
  },
};
</script>

<style scoped>
.v-menu__content {
  position: absolute !important;
  /* top: 53px !important; */
  right: 15px !important;
  width: fit-content !important;
  border-radius: 6px;
}
.navbar {
  position: relative !important;
}
.userName {
  font-size: 16px;
  color: #fff !important;
  font-weight: 600;
}
.admin-icon {
  color: #50af51 !important;
  font-size: 1.5rem;
  margin: 6px 14px 6px 0;
  /* padding: 0.5rem; */
  background: #fff;
  padding: 10px;
  border-radius: 0.25rem;
}
.edit-icon {
  position: relative;
  top: -1px;
}
.logout-icon {
  position: relative;
  left: -1px;
  top: -1px;
}
.user-icon {
  font-size: 1.5rem;
  /* color: #495664; */
  padding: 0.5rem;
  border-radius: 25px;
  width: 45px !important;
  height: 45px !important;
  vertical-align: middle;
  cursor: pointer;
}
.dash-icon,
.person-icon,
.setting-icon {
  color: #fff !important;
}
/* .user-icon:hover {
  color: #07489b;
  background-color: rgba(226, 230, 234, 0.48);
} */
.user-icon:active,
.user-icon:focus {
  background: none !important;
}
.router-link-active .itemLabel,
.router-link-active {
  color: #1c67b3;
  font-weight: 600 !important;
  width: 100%;
}
.router-link-active .itemIcon {
  background-color: #e6edf5;
  color: #1c67b3 !important;
  width: 100%;
  text-align: left;
  padding: 10px 12px;
  border-radius: 6px;
}
.sidenav-header-logo {
  margin: 14px 10px;
}
.inner-sidenav-icon {
  width: 30px;
}
.sidenav-icon {
  width: 41px;
  font-size: 18px;
  /* color:#fff; */
}
.item {
  /* padding:0 33px !important; */
  cursor: pointer;
}
.w-12 {
  width: 3rem !important;
}
.w-50 {
  width: 12.5rem !important;
}
.logo {
  max-width: 100%;
  height: auto;
}
.profileItem {
  padding-left: 1rem !important;
}
/* .profileItem .itemIcon {
  background-color: #1d215be3 !important;
} */
.profileItem .profileIcon {
  color: #444444;
  font-size: 20px !important;
}
.profileItem:hover .itemIcon {
  /* background-color: #07489b !important; */
  cursor: pointer;
}
.profileText {
  color: #444444 !important;
  font-size: 14px !important;
  position: relative;
  top: -4px;
  left: -9px;
}
.profile-menu {
  background: transparent !important;
  border-radius: 50px;
}

.profile-menu i {
  color: #333333 !important;
}
.clearVueLogo {
  display: inline-block;
  /* margin-right: 20px; */
}
.menu-items {
  height: 44px !important;
  padding: 0px !important;
  white-space: nowrap;
}
.itemIcon {
  background-color: transparent;
  color: #a7a7a7 !important;
  width: 100%;
  text-align: left;
  padding: 10px 12px;
  border-radius: 6px;
  font-size: 22px;
}
.itemLabel {
  color: #a7a7a7;
  font-size: 14px;
  white-space: nowrap;
  position: absolute;
  top: 15px;
  left: 64px;
}
.hamburger {
  top: 17px !important;
  left: 17px !important;
  width: 31px !important;
  height: 31px !important;
  background: transparent !important;
  box-shadow: none;
  cursor: pointer;
  color: #444444;
}
.hamburger:active,
.hamburger.active,
.hamburger:focus {
  background: transparent !important;
}
.hamburger .v-btn--outlined .v-btn__content .v-icon,
.hamburger .v-btn--round .v-btn__content .v-icon {
  background: transparent !important;
  outline: 0;
}
/* .stickyHeader {
  position: sticky;
  top: 0px;
  z-index: 9;
} */
.menu-items:hover .itemIcon {
  /* background-color: #07489b; */
  color: #1c67b3 !important;
}
.menu-items:hover .itemLabel {
  color: #1c67b3;
}
.drawer-class .v-list-group--active .listGroupItem {
  margin-left: 0;
  transition-duration: 1.5;
  transition-property: margin-left;
}
.listGroupItem {
  padding-right: 4px !important;
}
.v-btn:not(.v-btn--text):not(.v-btn--outlined):focus:before,
.theme--light.v-btn:focus::before {
  opacity: 0 !important;
}
.fs-25px {
  font-size: 25px;
}
.bt-10px {
  bottom: 10px;
}
.sidebarList {
  height: calc(100vh - 157px) !important;
  overflow-x: hidden;
  overflow-y: hidden;
  padding: 0 18px;
}
.sidebarList:hover {
  overflow-y: auto;
}
.sidebarList .v-list-item {
  min-height: 44px !important;
}
.status-indicator {
  display: block;
  position: absolute;
  top: -4px;
  right: 13px;
  width: 15px;
  height: 15px;
  border-radius: 50px;
  border: 2px solid #fff;
  background: #06d6a0;
  z-index: 2;
}
.user-avatar {
  display: none;
  width: 50px;
  height: 50px;
  background: #e6edf5;
  border-radius: 50px;
  text-align: center;
  line-height: 50px;
  color: #1c67b3;
  font-size: 20px;
  font-weight: 700;
}
.user-name-avatar {
  position: absolute;
  top: 4px;
  left: 80px;
  color: #444;
  font-weight: 600;
}
.user-position-avatar {
  color: #a7a7a7;
  font-size: 14px;
  white-space: nowrap;
  position: absolute;
  top: 27px;
  left: 80px;
}
.logout-avatar {
  /* position: absolute; */
  /* left: 220px; */
  /* left: 22px; */
  /* top: 7px; */
  width: 44px;
  height: 44px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 12px;
}
.logout-avatar:hover {
  background-color: #e6edf5 !important;
}
.logout-avatar i {
  font-size: 24px;
}
.logout-avatar:hover i {
  color: var(--primary) !important;
}
.sidebarList .active {
  background: #e6edf5;
  border-radius: 12px;
  width: 100%;
  height: 44px;
}
.sidebarList .active i {
  color: var(--primary) !important;
}

.sidebarList .v-list-item:hover {
  background: #2e2e2e10;
  border-radius: 12px;
}
</style>
